import { __extends } from "tslib";
import { axCoerceString } from '@awayjs/graphics';
import { Event } from './Event';
var GestureEvent = /** @class */ (function (_super) {
    __extends(GestureEvent, _super);
    function GestureEvent(type, bubbles, cancelable, phase, localX, localY, ctrlKey, altKey, shiftKey) {
        if (bubbles === void 0) { bubbles = true; }
        if (cancelable === void 0) { cancelable = false; }
        if (phase === void 0) { phase = null; }
        if (localX === void 0) { localX = 0; }
        if (localY === void 0) { localY = 0; }
        if (ctrlKey === void 0) { ctrlKey = false; }
        if (altKey === void 0) { altKey = false; }
        if (shiftKey === void 0) { shiftKey = false; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._phase = axCoerceString(phase);
        _this._localX = +localX;
        _this._localY = +localY;
        _this._ctrlKey = !!ctrlKey;
        _this._altKey = !!altKey;
        _this._shiftKey = !!shiftKey;
        return _this;
    }
    Object.defineProperty(GestureEvent.prototype, "localX", {
        // AS -> JS Bindings
        get: function () {
            return this._localX;
        },
        set: function (value) {
            this._localX = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GestureEvent.prototype, "localY", {
        get: function () {
            return this._localY;
        },
        set: function (value) {
            this._localY = +value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GestureEvent.prototype, "stageX", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GestureEvent.prototype, "stageY", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GestureEvent.prototype, "ctrlKey", {
        get: function () {
            return this._ctrlKey;
        },
        set: function (value) {
            this._ctrlKey = !!value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GestureEvent.prototype, "altKey", {
        get: function () {
            return this._altKey;
        },
        set: function (value) {
            this._altKey = !!value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GestureEvent.prototype, "shiftKey", {
        get: function () {
            return this._shiftKey;
        },
        set: function (value) {
            this._shiftKey = !!value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GestureEvent.prototype, "phase", {
        get: function () {
            return this._phase;
        },
        set: function (value) {
            this._phase = axCoerceString(value);
        },
        enumerable: false,
        configurable: true
    });
    GestureEvent.prototype.updateAfterEvent = function () { };
    GestureEvent.prototype.NativeCtor = function (phase, localX, localY, ctrlKey, altKey, shiftKey) {
        this._phase = axCoerceString(phase);
        this._localX = +localX;
        this._localY = +localY;
        this._ctrlKey = !!ctrlKey;
        this._altKey = !!altKey;
        this._shiftKey = !!shiftKey;
    };
    GestureEvent.prototype.clone = function () {
        return new GestureEvent(this.type, this.bubbles, this.cancelable, this.phase, this.localX, this.localY, this.ctrlKey, this.altKey, this.shiftKey);
    };
    GestureEvent.prototype.toString = function () {
        return this.formatToString('GestureEvent', 'type', 'bubbles', 'cancelable', 'eventPhase', 'localX', 'localY', 'ctrlKey', 'altKey', 'shiftKey');
    };
    GestureEvent.classInitializer = null;
    GestureEvent.classSymbols = null;
    GestureEvent.instanceSymbols = null;
    // JS -> AS Bindings
    GestureEvent.GESTURE_TWO_FINGER_TAP = 'gestureTwoFingerTap';
    return GestureEvent;
}(Event));
export { GestureEvent };
